import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Header from '../Components/Header'
import Body from '../Components/Body'
import FormPage from '../Components/FormPage'
const HomePage = () => {
  let count = 0
  const [toggle, setToggle] = useState("closed")

  return (
    <Container fluid className='container-body'>
      <Row>
        <Header setToggle={setToggle} />
      </Row>
      <Row>
        <Body count={count} />
      </Row>
      {toggle === "opened"
        ? <FormPage toggle={toggle} setToggle={setToggle} /> :
        <></>}
    </Container>
  )
}

export default HomePage